import './news-blogs-listing-hero.html.twig';
import './news-blogs-listing-hero.scss'

function toggleDropDownDisplay(dropdown) {
  if (dropdown.classList.contains('news-blogs-listing-hero__filter-dropdown--hidden')) {
    dropdown.classList.remove('news-blogs-listing-hero__filter-dropdown--hidden');
    dropdown.parentElement.classList.add('news-blogs-listing-hero__filter-select--open');
    return;
  }

  dropdown.classList.add('news-blogs-listing-hero__filter-dropdown--hidden');
  dropdown.parentElement.classList.remove('news-blogs-listing-hero__filter-select--open');
}

function filterChanged(filters) {
  if (filters.topics.length !== filters.initialSelection.length) {
    return true;
  }
  for (let initS of filters.initialSelection) {
    if (!filters.topics.includes(initS)) {
      return true; 
    }
  }    
  return false;      
}    

function triggerClick(event) {
  if (event.keyCode == 13) {
    event.target.click();
  }
}

export default function () {
  let filters = {
    topics: [],
    type: null,
    tag: null,
    initialSelection: []
  };

  let urlParams = new URLSearchParams(decodeURI(window.location.search));
  const el = document.querySelector('.news-blogs-listing-hero');
  if (!el) {
    return;
  }
  const topicSelector = el.querySelector('.news-blogs-listing-hero__filter-select--topic');

  // Country Filters
  if (topicSelector) {
    const topicDropdown = topicSelector.querySelector('.news-blogs-listing-hero__filter-dropdown');
    const topicOptions = topicDropdown.querySelectorAll('.news-blogs-listing-hero__filter-option label');
    const topicBtnWrapper = el.querySelector('.news-blogs-listing-hero__btn-wrapper');
    const topicBtn = el.querySelector('.news-blogs-listing-hero__filter-btn');
    let selectedTopics = [];
    let selectedType = null;
    let selectedTag = null;

    if (urlParams.has('topics')) {
      selectedTopics = urlParams.get('topics').split('_');
      filters.topics = selectedTopics;
      filters.initialSelection = selectedTopics.slice(); //clone
    }

    if (urlParams.has('type')) {
      selectedType = urlParams.get('type');
      if (selectedType.length > 0) {
        filters.type = selectedType;
      }
    }

    if (urlParams.has('tag')) {
      selectedTag = urlParams.get('tag');
      if (selectedTag.length > 0) {
        filters.tag = selectedTag;
      }
    }

    topicSelector.addEventListener('click', () => {
      toggleDropDownDisplay(topicDropdown);
    });

    topicSelector.addEventListener('keypress', (e) => {
      triggerClick(e);
    });

    topicOptions.forEach(topicOption => {
      topicOption.addEventListener('click', (e) => {
        const checkbox = topicDropdown.querySelector('input[type="checkbox"][name="' + topicOption.htmlFor + '"]');
        const topicId = checkbox.value;
        if (filters.topics.indexOf(topicId) !== -1) {
          filters.topics = filters.topics.filter((value) => value !== topicId);
        } else {
          filters.topics.push(topicId);
        }
        if (filterChanged(filters)) {
          topicBtnWrapper.classList.add('active');
        } else {
          topicBtnWrapper.classList.remove('active');
        }
        checkbox.click();
        checkbox.toggleAttribute('checked');
      });

      topicOption.addEventListener('keypress', (e) => {
        triggerClick(e);
        toggleDropDownDisplay(topicDropdown);
      });
    });

    topicBtn.addEventListener('click', () => {
      const filterParams = `${filters.topics.length > 0 ? `&topics=${filters.topics.join('_')}` : ''}${
        filters.type != null ? `&type=${filters.type}` : ''}${
        filters.tag != null ? `&tag=${filters.tag}` : ''}`;
      window.location.href = window.location.origin + window.location.pathname + filterParams.replace('&', '?');
    });

  }
}